import React from 'react';

import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableHeading from './TableHeading';
import TableItem from './TableItem';

const LineUpsTable = ({ data, title, subtitle }) => {
  return (
    <div className="Cmt-table-responsive">

      <Table>
        <TableHead>
          <TableHeading subtitle={subtitle} title={title} />
        </TableHead>
        <TableBody>
          {data && data.map(row => (
            <TableItem key={row?.api_player_id} row={row} />
          ))}
        </TableBody>
      </Table>
    </div>
  );
};

export default LineUpsTable;
